
import { useApolloFragmentLoader } from "./useApolloFragmentLoader.js";
import { useApolloLoadingLink } from "./useApolloLoadingLink.js";
import {ApolloClient, ApolloLink, InMemoryCache, split} from "@apollo/client/core";
import { setContext } from '@apollo/client/link/context';
import { BatchHttpLink } from "@apollo/client/link/batch-http";

import {createUploadLink} from "apollo-upload-client";
import {createFragmentRegistry} from "@apollo/client/cache";
import { extractFiles, isExtractableFile } from "extract-files";


export const useApolloClient = () => {

    const {
        getFragmentRegistry
    } = useApolloFragmentLoader()

    const createApolloClient = (options = {}) => {

        const {
            graphqlBaseUrl,
            loadingLink,
            errorLink,
            authContext,
            router,
            uri
        } = options

        const resolveUploadUri = (() => {

            // URI come stringa
            if (typeof uri === 'string') {
                return () => uri
            }

            // una funzione personalizzata
            if (typeof uri === 'function') {
                return () => uri({ graphqlBaseUrl, router })
            }

            // Default: logica attuale con tenantId da window.location
            return () => {
                const path         = window.location.pathname
                const tenantIdMatch = path.match(/^\/([^\/]+)/)
                const tenantId      = tenantIdMatch ? tenantIdMatch[1] : null
                const globalSegments = ['login', 'auth', 'public', 'apps', 'workspaces', 'setup']

                if (!tenantId || globalSegments.includes(tenantId)) {
                    return `${graphqlBaseUrl}/graphql`
                }

                return `${graphqlBaseUrl}/${tenantId}/graphql`
            }

        })()

        const uploadLink = createUploadLink({
            uri: resolveUploadUri,
            credentials: 'include',
        })

        const batchLink = new BatchHttpLink({
            uri: resolveUploadUri,
            credentials: 'include',
            batchInterval: 20,
            batchMax: 10,
        })

        const hasFiles = (operation) => {
            const { files } = extractFiles({ variables: operation.variables }, '', isExtractableFile)
            return files.size > 0
        }

        const httpLink = split(hasFiles, uploadLink, batchLink)

        return new ApolloClient({
            link: ApolloLink.from([
                errorLink,
                authContext,
                loadingLink,
                httpLink,
            ]),
            cache: new InMemoryCache({
                fragments: getFragmentRegistry(import.meta.glob('../graphql/fragments/*.graphql', { eager: true })),

                possibleTypes: {
                    MediaInterface: ['Media', 'ProductMedia', 'ProductVariationMedia'],
                    AttachmentInterface: ['AttachmentWithPriority', 'Attachment'],
                    ProductInterface: ['ProductWithoutVariations', 'Product']
                },

                /*
                typePolicies: {
                    Media: {
                        keyFields: false
                    }
                }
                */

            })
        })

    }

    return {
        createApolloClient
    }
}
